import * as Actions from 'app/store/actions/notifications/notifications.actions';

const initialState = null;

const notifications = (state = initialState, action) => {
	switch (action.type) {
		case Actions.GET_CHAT_NOTIFICATION_LIST: {
			return {
				...state,
				notifications : action.data
			};
		}
		default: {
			return state;
		}
	}
};

export default notifications;
